export default "__VITE_ASSET__CkPH2w3P__"